/** Returns correct Russian word form for a given number.
 * @example pluralRu(1, "событие", "события", "событий") → "событие"
 * @example pluralRu(3, "событие", "события", "событий") → "события"
 * @example pluralRu(11, "событие", "события", "событий") → "событий"
 */
export function pluralRu(n: number, one: string, few: string, many: string): string {
  const abs = Math.abs(n) % 100
  const mod10 = abs % 10
  if (abs >= 11 && abs <= 14) return many
  if (mod10 === 1) return one
  if (mod10 >= 2 && mod10 <= 4) return few
  return many
}
